module.exports = __webpack_public_path__ + "img/borderRightArrow2White.ddce82eb.svg";